<template>
  <div class="invitation-manage">
    <div class="menu-title">邀请码管理</div>
    <div class="menu-content">
      <el-form
        :inline="true"
        :model="qo"
        size="small"
        class="filter-form"
        @submit.native.prevent="search"
      >
        <el-form-item label="邀请码">
          <el-input
            v-model="qo.invitation_code"
            clearable
            placeholder="请输入邀请码"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item label="设备号">
          <el-input
            v-model="qo.device_code"
            clearable
            placeholder="请输入设备号"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item label="渠道">
          <el-input
            v-model="qo.channel"
            clearable
            maxlength="64"
            placeholder="请输入渠道"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item label="账号">
          <el-input
            v-model="qo.account"
            clearable
            placeholder="请输入账号"
            @keyup.enter.native="search"
          />
        </el-form-item>
        <el-form-item label="分配状态">
          <el-select v-model="qo.assigned" clearable placeholder="全部">
            <el-option label="已分配" :value="true" />
            <el-option label="未分配" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item label="绑定状态">
          <el-select v-model="qo.bound" clearable placeholder="全部">
            <el-option label="已绑定" :value="true" />
            <el-option label="未绑定" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item label="冻结状态">
          <el-select v-model="qo.frozen" clearable placeholder="全部">
            <el-option label="已冻结" :value="true" />
            <el-option label="未冻结" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item label="删除状态">
          <el-select v-model="qo.removed" clearable placeholder="未删除">
            <el-option label="已删除" :value="true" />
            <el-option label="未删除" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item label="激活期限">
          <el-select v-model="qo.validity" clearable placeholder="全部">
            <el-option label="生效中" value="permanent" />
            <el-option label="未生效" value="not_active" />
            <el-option label="可激活" value="valid" />
            <el-option label="已过期" value="expired" />
            <el-option label="待领取计时" value="unclaimed" />
          </el-select>
        </el-form-item>
        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="search">
            查询
          </el-button>
          <el-button icon="el-icon-refresh" :disabled="listLoading" @click="resetFilters">
            重置
          </el-button>
        </el-form-item>
      </el-form>

      <div class="toolbar">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="createRow">
          创建邀请码
        </el-button>
      </div>

      <div class="table-list">
        <el-table
          v-loading="listLoading"
          :data="result.records"
          :row-class-name="tableRowClassName"
          row-key="id"
          border
          stripe
        >
          <el-table-column label="序号" width="64" align="center">
            <template slot-scope="scope">
              {{ (qo.pageNo - 1) * qo.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="邀请码" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="code-value">{{ scope.row.invitation_code || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="device_code" label="设备号" min-width="170" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.device_code || '-' }}</template>
          </el-table-column>
          <el-table-column prop="channel" label="渠道" min-width="110" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.channel || '-' }}</template>
          </el-table-column>
          <el-table-column prop="account" label="账号" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.account || scope.row.qq_account || '-' }}</template>
          </el-table-column>
          <el-table-column prop="starts_at" label="生效时间" min-width="168">
            <template slot-scope="scope">{{ scope.row.starts_at || (scope.row.activation_ttl_hours ? '领取后生效' : '立即生效') }}</template>
          </el-table-column>
          <el-table-column label="激活截止时间" min-width="168">
            <template slot-scope="scope">
              <div>{{ scope.row.expires_at || (scope.row.activation_ttl_hours ? '领取后计算' : '永久') }}</div>
              <div v-if="scope.row.activation_ttl_hours" class="cell-note">领取后 {{ scope.row.activation_ttl_hours }} 小时内激活</div>
              <div v-if="scope.row.device_code" class="cell-note">已绑定，首次激活时间窗口不影响使用</div>
            </template>
          </el-table-column>
          <el-table-column label="分配 / 创建" min-width="176">
            <template slot-scope="scope">
              <div class="cell-line"><span>分配</span>{{ formatDateTime(scope.row.assigned_at) }}</div>
              <div class="cell-line"><span>创建</span>{{ formatDateTime(scope.row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="冻结信息" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <template v-if="scope.row.frozen">
                <div class="freeze-reason">{{ scope.row.freeze_reason || '-' }}</div>
                <div class="cell-note">{{ formatDateTime(scope.row.frozen_at) }}</div>
              </template>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" min-width="174">
            <template slot-scope="scope">
              <div class="status-tags">
                <el-tag
                  v-for="tag in statusTags(scope.row)"
                  :key="tag.key"
                  :type="tag.type"
                  size="mini"
                  effect="plain"
                >
                  {{ tag.label }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="178" fixed="right" align="center">
            <template slot-scope="scope">
              <div class="row-actions">
                <el-tooltip v-if="canCopyRow(scope.row)" content="复制邀请码" placement="top">
                  <el-button
                    type="text"
                    icon="el-icon-document-copy"
                    aria-label="复制邀请码"
                    :disabled="rowActionBusy(scope.row.id)"
                    @click="copyInvitationCode(scope.row)"
                  />
                </el-tooltip>
                <el-tooltip v-if="canEditRow(scope.row)" content="编辑" placement="top">
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    aria-label="编辑"
                    :disabled="rowActionBusy(scope.row.id)"
                    @click="modifyRow(scope.row)"
                  />
                </el-tooltip>
                <el-tooltip v-if="canToggleFreezeRow(scope.row)" :content="scope.row.frozen ? '解冻' : '冻结'" placement="top">
                  <el-button
                    type="text"
                    :class="{ 'danger-action': !scope.row.frozen }"
                    :icon="scope.row.frozen ? 'el-icon-unlock' : 'el-icon-lock'"
                    :aria-label="scope.row.frozen ? '解冻' : '冻结'"
                    :disabled="rowActionBusy(scope.row.id)"
                    @click="openFreezeDialog(scope.row)"
                  />
                </el-tooltip>
                <el-tooltip content="审计历史" placement="top">
                  <el-button
                    type="text"
                    icon="el-icon-time"
                    aria-label="审计历史"
                    :disabled="rowActionBusy(scope.row.id)"
                    @click="openHistory(scope.row)"
                  />
                </el-tooltip>
                <el-tooltip v-if="canRemoveRow(scope.row)" content="逻辑删除" placement="top">
                  <el-button
                    type="text"
                    class="danger-action"
                    icon="el-icon-delete"
                    aria-label="逻辑删除"
                    :loading="isRemoving(scope.row.id)"
                    :disabled="rowActionBusy(scope.row.id)"
                    @click="removeRow(scope.row)"
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          background
          :current-page="qo.pageNo"
          :page-size="qo.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next"
          :total="result.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>

    <el-dialog
      title="创建邀请码"
      :visible.sync="createDialogVisible"
      :close-on-click-modal="false"
      width="560px"
      top="6vh"
      @closed="clearCreateForm"
    >
      <el-form ref="createForm" :model="createForm" :rules="createRules" label-position="top" size="small" class="metadata-form">
        <el-form-item label="数量" prop="countIn">
          <el-input-number
            v-model="createForm.countIn"
            :min="1"
            :max="9999"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="渠道" prop="channel">
          <el-input v-model="createForm.channel" clearable maxlength="64" show-word-limit />
        </el-form-item>
        <el-form-item label="账号" prop="account">
          <el-input
            v-model="createForm.account"
            clearable
            placeholder="最多 64 个字符，不能包含控制或格式字符"
          />
        </el-form-item>
        <el-form-item label="有效期模式">
          <el-select v-model="createForm.validity_mode" @change="handleValidityModeChange('create')">
            <el-option label="永久" value="permanent" />
            <el-option label="固定时间" value="fixed" />
            <el-option label="领取后计时" value="relative" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="createForm.validity_mode === 'relative'" label="领取后有效时长（小时）" prop="activation_ttl_hours">
          <el-input-number v-model="createForm.activation_ttl_hours" :min="1" :max="8760" :step="1" controls-position="right" />
          <div class="form-note">1–8760 小时，领取成功后开始计时；超时未激活可重新领取。</div>
        </el-form-item>
        <el-form-item v-if="createForm.validity_mode !== 'relative'" label="生效时间" prop="starts_at">
          <el-date-picker
            v-model="createForm.starts_at"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="空表示立即生效（北京时间）"
            clearable
            @change="handleStartsAtChange('create')"
          />
        </el-form-item>
        <el-form-item v-if="createForm.validity_mode === 'fixed'" label="激活截止时间" prop="expires_at">
          <el-date-picker
            v-model="createForm.expires_at"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="北京时间"
            clearable
            @change="handleExpiryChange('create')"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" :disabled="createSubmitting" @click="createDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="createSubmitting" @click="submitCreate">确认创建</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑邀请码"
      :visible.sync="modifyDialogVisible"
      :close-on-click-modal="false"
      width="560px"
      top="6vh"
      @closed="clearModifyForm"
    >
      <el-form ref="modifyForm" :model="modifyForm" :rules="modifyRules" label-position="top" size="small" class="metadata-form">
        <el-form-item label="邀请码">
          <el-input :value="modifyForm.invitation_code" disabled />
        </el-form-item>
        <el-form-item label="渠道" prop="channel">
          <el-input
            v-model="modifyForm.channel"
            clearable
            maxlength="64"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="账号" prop="account">
          <el-input
            v-model="modifyForm.account"
            clearable
            placeholder="最多 64 个字符，不能包含控制或格式字符"
          />
        </el-form-item>
        <el-form-item label="有效期模式">
          <el-select v-model="modifyForm.validity_mode" :disabled="modifyForm.relativeLocked" @change="handleValidityModeChange('modify')">
            <el-option label="永久" value="permanent" />
            <el-option label="固定时间" value="fixed" />
            <el-option label="领取后计时" value="relative" :disabled="modifyForm.bound && modifyForm.validity_mode !== 'relative'" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="modifyForm.validity_mode === 'relative'" label="领取后有效时长（小时）" prop="activation_ttl_hours">
          <el-input-number v-model="modifyForm.activation_ttl_hours" :min="1" :max="8760" :step="1" :disabled="modifyForm.relativeLocked" controls-position="right" />
          <div class="form-note">1–8760 小时，领取成功后开始计时；超时未激活可重新领取。</div>
          <div v-if="modifyForm.relativeLocked" class="form-note">已开始计时或已绑定，不能修改有效期；渠道和账号仍可编辑。</div>
        </el-form-item>
        <el-form-item v-if="modifyForm.validity_mode !== 'relative'" label="生效时间" prop="starts_at">
          <el-date-picker
            v-model="modifyForm.starts_at"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="空表示立即生效（北京时间）"
            clearable
            @change="handleStartsAtChange('modify')"
          />
        </el-form-item>
        <el-form-item v-if="modifyForm.validity_mode === 'fixed'" label="激活截止时间" prop="expires_at">
          <el-date-picker
            v-model="modifyForm.expires_at"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="北京时间"
            clearable
            @change="handleExpiryChange('modify')"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" :disabled="modifySubmitting" @click="modifyDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="modifySubmitting" @click="submitModify">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="freezeDialogTitle"
      :visible.sync="freezeDialogVisible"
      :close-on-click-modal="false"
      width="500px"
      top="10vh"
      @closed="clearFreezeForm"
    >
      <el-alert
        :title="freezeForm.frozen ? '冻结后，邀请码及已绑定设备将在后续校验时被拒绝。' : '解冻将解除此邀请码记录对应的设备封禁。'"
        :type="freezeForm.frozen ? 'warning' : 'info'"
        :closable="false"
        show-icon
        class="dialog-alert"
      />
      <el-form ref="freezeForm" :model="freezeForm" :rules="freezeRules" label-width="88px" size="small">
        <el-form-item :label="freezeForm.frozen ? '冻结原因' : '解冻备注'" prop="reason">
          <el-input
            v-model="freezeForm.reason"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
            :placeholder="freezeForm.frozen ? '必填，将写入审计历史' : '可选，将写入审计历史'"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" :disabled="freezeSubmitting" @click="freezeDialogVisible = false">取消</el-button>
        <el-button
          :type="freezeForm.frozen ? 'danger' : 'primary'"
          size="small"
          :loading="freezeSubmitting"
          @click="submitFreeze"
        >
          {{ freezeForm.frozen ? '确认冻结' : '确认解冻' }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="historyDialogTitle"
      :visible.sync="historyDialogVisible"
      :close-on-click-modal="false"
      width="720px"
      top="6vh"
      @closed="clearHistory"
    >
      <el-table v-loading="historyLoading" :data="historyRecords" border stripe max-height="480">
        <el-table-column label="动作" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="historyTagType(scope.row.action)" size="mini" effect="plain">
              {{ historyActionLabel(scope.row.action) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="原因 / 备注" min-width="260" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.reason || '-' }}</template>
        </el-table-column>
        <el-table-column prop="actor" label="操作人" min-width="130">
          <template slot-scope="scope">{{ scope.row.actor || '-' }}</template>
        </el-table-column>
        <el-table-column prop="created_at" label="操作时间" width="180">
          <template slot-scope="scope">{{ formatDateTime(scope.row.created_at) }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="historyDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';

const QUERY_STRING_FIELDS = ['invitation_code', 'device_code', 'channel', 'account', 'validity'];
const QUERY_BOOLEAN_FIELDS = ['assigned', 'bound', 'frozen', 'removed'];
const FORMAT_CHARACTER_PATTERN = /\p{Cf}/u;

function createQueryForm() {
  return {
    pageNo: 1,
    pageSize: 10,
    invitation_code: '',
    device_code: '',
    channel: '',
    account: '',
    assigned: '',
    bound: '',
    frozen: '',
    removed: '',
    validity: ''
  };
}

function createMetadataForm() {
  return {
    channel: '',
    account: '',
    starts_at: null,
    expires_at: null,
    permanent: true,
    validity_mode: 'permanent',
    activation_ttl_hours: 24,
    relativeLocked: false,
    bound: false
  };
}

function normalizeNullableString(value) {
  const normalized = value === null || value === undefined ? '' : String(value).trim();
  return normalized || null;
}

function buildQueryPayload(qo) {
  const pageNo = Number(qo.pageNo);
  const pageSize = Number(qo.pageSize);
  const payload = {
    pageNo: Number.isInteger(pageNo) && pageNo > 0 ? pageNo : 1,
    pageSize: Number.isInteger(pageSize) && pageSize > 0 && pageSize <= 100 ? pageSize : 10
  };

  QUERY_STRING_FIELDS.forEach(field => {
    const value = normalizeNullableString(qo[field]);
    if (value !== null) payload[field] = value;
  });
  QUERY_BOOLEAN_FIELDS.forEach(field => {
    if (typeof qo[field] === 'boolean') payload[field] = qo[field];
  });
  return payload;
}

function buildMetadataPayload(form) {
  const owner = {
    channel: normalizeNullableString(form.channel),
    account: normalizeNullableString(form.account)
  };
  // 已计时的相对期限由服务端锁定，编辑账号时不重写时间或时长。
  if (form.relativeLocked) return owner;
  if (form.validity_mode === 'relative') {
    return Object.assign(owner, {
      activation_ttl_hours: form.activation_ttl_hours,
      starts_at: null,
      expires_at: null
    });
  }
  return Object.assign(owner, {
    activation_ttl_hours: null,
    starts_at: normalizeNullableString(form.starts_at),
    expires_at: form.permanent ? null : normalizeNullableString(form.expires_at)
  });
}

function validateActivationHours(form, value) {
  if (form.validity_mode !== 'relative' || form.relativeLocked) return '';
  return Number.isInteger(value) && value >= 1 && value <= 8760
    ? '' : '请填写 1 至 8760 的整数小时';
}

function parseBeijingDateTime(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/.exec(String(value || ''));
  if (!match) return NaN;
  const parts = match.slice(1).map(Number);
  const timestamp = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3] - 8, parts[4], parts[5]);
  const beijingDate = new Date(timestamp + 8 * 60 * 60 * 1000);
  const valid = beijingDate.getUTCFullYear() === parts[0]
    && beijingDate.getUTCMonth() === parts[1] - 1
    && beijingDate.getUTCDate() === parts[2]
    && beijingDate.getUTCHours() === parts[3]
    && beijingDate.getUTCMinutes() === parts[4]
    && beijingDate.getUTCSeconds() === parts[5];
  return valid ? timestamp : NaN;
}

function validateStartsAtSelection(value, permanent, expiresAt) {
  const normalized = normalizeNullableString(value);
  if (normalized === null) return '';
  const timestamp = parseBeijingDateTime(normalized);
  if (!Number.isFinite(timestamp)) return '生效时间格式应为 YYYY-MM-DD HH:mm:ss';
  const normalizedExpiresAt = normalizeNullableString(expiresAt);
  if (!permanent && normalizedExpiresAt !== null) {
    const expiresTimestamp = parseBeijingDateTime(normalizedExpiresAt);
    if (Number.isFinite(expiresTimestamp) && timestamp >= expiresTimestamp) {
      return '生效时间必须早于激活截止时间';
    }
  }
  return '';
}

function validateExpirySelection(permanent, value, originalValue, allowOriginal, startsAt, nowTimestamp) {
  if (permanent) return '';
  const normalized = normalizeNullableString(value);
  if (normalized === null) return '请选择激活截止时间，或切换为永久激活期限';
  const timestamp = parseBeijingDateTime(normalized);
  if (!Number.isFinite(timestamp)) return '激活截止时间格式应为 YYYY-MM-DD HH:mm:ss';
  const normalizedStartsAt = normalizeNullableString(startsAt);
  if (normalizedStartsAt !== null) {
    const startsTimestamp = parseBeijingDateTime(normalizedStartsAt);
    if (Number.isFinite(startsTimestamp) && startsTimestamp >= timestamp) {
      return '生效时间必须早于激活截止时间';
    }
  }
  if (allowOriginal && normalized === normalizeNullableString(originalValue)) return '';
  const now = Number.isFinite(nowTimestamp) ? nowTimestamp : Date.now();
  return timestamp > now ? '' : '修改后的激活截止时间必须晚于当前时间';
}

function validateChannelField(rule, value, callback) {
  const normalized = normalizeNullableString(value);
  callback(normalized !== null && normalized.length > 64 ? new Error('渠道最多 64 个字符') : undefined);
}

function validateAccountValue(value) {
  if (value === null || value === undefined || value === '') return '';
  const raw = String(value);
  const hasControlCharacter = Array.from(raw).some(character => {
    const codePoint = character.codePointAt(0);
    return codePoint <= 0x1f || (codePoint >= 0x7f && codePoint <= 0x9f);
  });
  if (hasControlCharacter) return '账号不能包含控制字符';
  if (FORMAT_CHARACTER_PATTERN.test(raw)) return '账号不能包含 Unicode 格式字符';
  const normalized = raw.trim();
  if (!normalized) return '账号不能全为空白';
  return Array.from(normalized).length > 64 ? '账号最多 64 个字符' : '';
}

function validateAccountField(rule, value, callback) {
  const message = validateAccountValue(value);
  callback(message ? new Error(message) : undefined);
}

function validateCountField(rule, value, callback) {
  const count = Number(value);
  callback(!Number.isInteger(count) || count < 1 || count > 9999
    ? new Error('数量必须是 1 至 9999 的整数')
    : undefined);
}

function validateFreezeReason(frozen, value) {
  const reason = normalizeNullableString(value);
  if (reason !== null && reason.length > 500) return '原因最多 500 个字符';
  if (frozen && reason === null) return '请填写冻结原因';
  return '';
}

function getRowAccount(row) {
  return normalizeNullableString(row && row.account) || normalizeNullableString(row && row.qq_account);
}

function canEditInvitation(row) {
  return !row.removed;
}

function canRemoveInvitation(row) {
  return !row.removed;
}

function canCopyInvitation(row) {
  return !row.removed && Boolean(normalizeNullableString(row.invitation_code));
}

function canToggleFreeze(row) {
  return !row.removed || Boolean(row.frozen);
}

function copyTextFallback(value) {
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  try {
    return typeof document.execCommand === 'function' && document.execCommand('copy');
  } catch (error) {
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
}

function axiosErrorMessage(error, fallback) {
  if (error && error.response && error.response.data && error.response.data.msg) {
    return error.response.data.msg;
  }
  return error && error.message ? error.message : fallback;
}

export default {
  name: 'InvitationDeviceManage',
  data() {
    return {
      qo: createQueryForm(),
      result: {
        records: [],
        total: 0
      },
      listLoading: false,
      reloadPending: false,
      createDialogVisible: false,
      createSubmitting: false,
      createForm: Object.assign({ countIn: 1 }, createMetadataForm()),
      modifyDialogVisible: false,
      modifySubmitting: false,
      modifyOriginalExpiresAt: null,
      modifyForm: Object.assign({ id: null, invitation_code: '' }, createMetadataForm()),
      freezeDialogVisible: false,
      freezeSubmitting: false,
      freezeTarget: null,
      freezeForm: {
        frozen: true,
        reason: ''
      },
      historyDialogVisible: false,
      historyLoading: false,
      historyTarget: null,
      historyRecords: [],
      removingIds: {},
      createRules: {
        activation_ttl_hours: [{
          validator: (rule, value, callback) => {
            const message = validateActivationHours(this.createForm, value);
            callback(message ? new Error(message) : undefined);
          },
          trigger: ['blur', 'change']
        }],
        countIn: [{ validator: validateCountField, trigger: 'change' }],
        channel: [{ validator: validateChannelField, trigger: ['blur', 'change'] }],
        account: [{ validator: validateAccountField, trigger: ['blur', 'change'] }],
        starts_at: [{
          validator: (rule, value, callback) => {
            const message = validateStartsAtSelection(
              value,
              this.createForm.permanent,
              this.createForm.expires_at
            );
            callback(message ? new Error(message) : undefined);
          },
          trigger: 'change'
        }],
        expires_at: [{
          validator: (rule, value, callback) => {
            const message = validateExpirySelection(
              this.createForm.permanent,
              value,
              null,
              false,
              this.createForm.starts_at
            );
            callback(message ? new Error(message) : undefined);
          },
          trigger: 'change'
        }]
      },
      modifyRules: {
        activation_ttl_hours: [{
          validator: (rule, value, callback) => {
            const message = validateActivationHours(this.modifyForm, value);
            callback(message ? new Error(message) : undefined);
          },
          trigger: ['blur', 'change']
        }],
        channel: [{ validator: validateChannelField, trigger: ['blur', 'change'] }],
        account: [{ validator: validateAccountField, trigger: ['blur', 'change'] }],
        starts_at: [{
          validator: (rule, value, callback) => {
            const message = validateStartsAtSelection(
              value,
              this.modifyForm.permanent,
              this.modifyForm.expires_at
            );
            callback(message ? new Error(message) : undefined);
          },
          trigger: 'change'
        }],
        expires_at: [{
          validator: (rule, value, callback) => {
            const message = validateExpirySelection(
              this.modifyForm.permanent,
              value,
              this.modifyOriginalExpiresAt,
              true,
              this.modifyForm.starts_at
            );
            callback(message ? new Error(message) : undefined);
          },
          trigger: 'change'
        }]
      },
      freezeRules: {
        reason: [{
          validator: (rule, value, callback) => {
            const message = validateFreezeReason(this.freezeForm.frozen, value);
            callback(message ? new Error(message) : undefined);
          },
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  computed: {
    freezeDialogTitle() {
      const code = this.freezeTarget && this.freezeTarget.invitation_code;
      return `${this.freezeForm.frozen ? '冻结' : '解冻'}邀请码${code ? `：${code}` : ''}`;
    },
    historyDialogTitle() {
      const code = this.historyTarget && this.historyTarget.invitation_code;
      return `审计历史${code ? `：${code}` : ''}`;
    }
  },
  mounted() {
    this.queryData();
  },
  methods: {
    async queryData() {
      const accountMessage = validateAccountValue(this.qo.account);
      if (accountMessage) {
        this.$message.warning(accountMessage);
        return false;
      }
      if (this.listLoading) {
        this.reloadPending = true;
        return false;
      }
      this.listLoading = true;
      try {
        const result = await request({
          url: '/api/v1/invitation_device/query_pages',
          method: 'post',
          data: buildQueryPayload(this.qo)
        });
        this.result.records = result && Array.isArray(result.records) ? result.records : [];
        this.result.total = Number(result && result.total) || 0;
        return true;
      } catch (error) {
        this.reportRequestError(error, '查询邀请码失败');
        return false;
      } finally {
        this.listLoading = false;
        if (this.reloadPending) {
          this.reloadPending = false;
          this.$nextTick(() => this.queryData());
        }
      }
    },
    search() {
      this.qo.pageNo = 1;
      this.queryData();
    },
    resetFilters() {
      const pageSize = this.qo.pageSize;
      this.qo = createQueryForm();
      this.qo.pageSize = pageSize;
      this.queryData();
    },
    handleCurrentChange(pageNo) {
      this.qo.pageNo = pageNo;
      this.queryData();
    },
    handleSizeChange(pageSize) {
      this.qo.pageNo = 1;
      this.qo.pageSize = pageSize;
      this.queryData();
    },
    createRow() {
      this.createForm = Object.assign({ countIn: 1 }, createMetadataForm());
      this.createDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.createForm) this.$refs.createForm.clearValidate();
      });
    },
    clearCreateForm() {
      if (this.createSubmitting) return;
      this.createForm = Object.assign({ countIn: 1 }, createMetadataForm());
    },
    async submitCreate() {
      if (this.createSubmitting) return;
      this.createSubmitting = true;
      try {
        if (!(await this.validateForm('createForm'))) return;
        await request({
          url: `/api/v1/invitation_device/create/${Number(this.createForm.countIn)}`,
          method: 'post',
          data: buildMetadataPayload(this.createForm)
        });
        this.$message.success('创建成功');
        this.createDialogVisible = false;
        this.qo.pageNo = 1;
        await this.queryData();
      } catch (error) {
        this.reportRequestError(error, '创建邀请码失败');
      } finally {
        this.createSubmitting = false;
      }
    },
    modifyRow(row) {
      if (!canEditInvitation(row)) return;
      this.modifyOriginalExpiresAt = normalizeNullableString(row.expires_at);
      this.modifyForm = {
        id: row.id,
        invitation_code: row.invitation_code || '',
        channel: row.channel || '',
        account: getRowAccount(row) || '',
        starts_at: normalizeNullableString(row.starts_at),
        expires_at: this.modifyOriginalExpiresAt,
        permanent: this.modifyOriginalExpiresAt === null,
        validity_mode: row.activation_ttl_hours != null ? 'relative' : this.modifyOriginalExpiresAt === null ? 'permanent' : 'fixed',
        activation_ttl_hours: row.activation_ttl_hours == null ? 24 : row.activation_ttl_hours,
        relativeLocked: row.activation_ttl_hours != null && Boolean(row.expires_at || row.device_code),
        bound: Boolean(row.device_code)
      };
      this.modifyDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.modifyForm) this.$refs.modifyForm.clearValidate();
      });
    },
    clearModifyForm() {
      if (this.modifySubmitting) return;
      this.modifyOriginalExpiresAt = null;
      this.modifyForm = Object.assign({ id: null, invitation_code: '' }, createMetadataForm());
    },
    async submitModify() {
      if (this.modifySubmitting || !this.modifyForm.id) return;
      this.modifySubmitting = true;
      try {
        if (!(await this.validateForm('modifyForm'))) return;
        await request({
          url: '/api/v1/invitation_device/modify',
          method: 'post',
          data: Object.assign({ id: this.modifyForm.id }, buildMetadataPayload(this.modifyForm))
        });
        this.$message.success('保存成功');
        this.modifyDialogVisible = false;
        await this.queryData();
      } catch (error) {
        this.reportRequestError(error, '修改邀请码失败');
      } finally {
        this.modifySubmitting = false;
      }
    },
    handleValidityModeChange(mode) {
      const form = mode === 'create' ? this.createForm : this.modifyForm;
      form.permanent = form.validity_mode === 'permanent';
      if (form.validity_mode === 'relative') {
        form.starts_at = null;
        form.expires_at = null;
      } else if (form.permanent) {
        form.expires_at = null;
      }
      this.$nextTick(() => {
        const ref = this.$refs[mode === 'create' ? 'createForm' : 'modifyForm'];
        if (ref) ref.clearValidate();
      });
    },
    handlePermanentChange(mode) {
      const form = mode === 'create' ? this.createForm : this.modifyForm;
      const refName = mode === 'create' ? 'createForm' : 'modifyForm';
      if (form.permanent) form.expires_at = null;
      this.$nextTick(() => {
        const formRef = this.$refs[refName];
        if (!formRef) return;
        formRef.clearValidate('expires_at');
        formRef.validateField('starts_at');
      });
    },
    handleStartsAtChange(mode) {
      const form = mode === 'create' ? this.createForm : this.modifyForm;
      const refName = mode === 'create' ? 'createForm' : 'modifyForm';
      if (form.permanent) return;
      this.$nextTick(() => {
        if (this.$refs[refName]) this.$refs[refName].validateField('expires_at');
      });
    },
    handleExpiryChange(mode) {
      const form = mode === 'create' ? this.createForm : this.modifyForm;
      const refName = mode === 'create' ? 'createForm' : 'modifyForm';
      if (!form.expires_at) {
        form.permanent = true;
        form.validity_mode = 'permanent';
        this.handlePermanentChange(mode);
        return;
      }
      this.$nextTick(() => {
        if (this.$refs[refName]) this.$refs[refName].validateField('starts_at');
      });
    },
    openFreezeDialog(row) {
      if (!canToggleFreeze(row) || this.freezeSubmitting) return;
      this.freezeTarget = row;
      this.freezeForm = {
        frozen: !row.frozen,
        reason: ''
      };
      this.freezeDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.freezeForm) this.$refs.freezeForm.clearValidate();
      });
    },
    clearFreezeForm() {
      if (this.freezeSubmitting) return;
      this.freezeTarget = null;
      this.freezeForm = { frozen: true, reason: '' };
    },
    async submitFreeze() {
      if (this.freezeSubmitting || !this.freezeTarget) return;
      this.freezeSubmitting = true;
      try {
        if (!(await this.validateForm('freezeForm'))) return;
        await request({
          url: '/api/v1/invitation_device/freeze',
          method: 'post',
          data: {
            id: this.freezeTarget.id,
            frozen: this.freezeForm.frozen,
            reason: normalizeNullableString(this.freezeForm.reason) || ''
          }
        });
        this.$message.success(this.freezeForm.frozen ? '冻结成功' : '解冻成功');
        this.freezeDialogVisible = false;
        await this.queryData();
      } catch (error) {
        this.reportRequestError(error, this.freezeForm.frozen ? '冻结失败' : '解冻失败');
      } finally {
        this.freezeSubmitting = false;
      }
    },
    async openHistory(row) {
      if (this.historyLoading) return;
      this.historyTarget = row;
      this.historyRecords = [];
      this.historyDialogVisible = true;
      this.historyLoading = true;
      try {
        const result = await request({
          url: `/api/v1/invitation_device/history/${row.id}`,
          method: 'get'
        });
        this.historyRecords = Array.isArray(result) ? result : [];
      } catch (error) {
        this.reportRequestError(error, '读取审计历史失败');
      } finally {
        this.historyLoading = false;
      }
    },
    clearHistory() {
      if (this.historyLoading) return;
      this.historyTarget = null;
      this.historyRecords = [];
    },
    async removeRow(row) {
      if (!canRemoveInvitation(row) || this.rowActionBusy(row.id)) return;
      const key = String(row.id);
      this.$set(this.removingIds, key, true);
      try {
        try {
          await this.$confirm(
            '删除后邀请码将在下次启动校验时不可用；若记录仍处于冻结状态，删除不会解除设备冻结。是否继续？',
            '确认逻辑删除',
            {
              confirmButtonText: '逻辑删除',
              cancelButtonText: '取消',
              type: 'warning'
            }
          );
        } catch (error) {
          return;
        }
        await request({
          url: `/api/v1/invitation_device/remove/${row.id}`,
          method: 'post'
        });
        this.$message.success('已逻辑删除');
        if (this.result.records.length === 1 && this.qo.pageNo > 1) this.qo.pageNo -= 1;
        await this.queryData();
      } catch (error) {
        this.reportRequestError(error, '删除邀请码失败');
      } finally {
        this.$delete(this.removingIds, key);
      }
    },
    async copyInvitationCode(row) {
      if (!canCopyInvitation(row)) return;
      const value = String(row.invitation_code);
      let copied = false;
      if (typeof navigator !== 'undefined' && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        try {
          await navigator.clipboard.writeText(value);
          copied = true;
        } catch (error) {
          copied = false;
        }
      }
      if (!copied) copied = copyTextFallback(value);
      if (copied) this.$message.success('邀请码已复制');
      else this.$message.error('浏览器无法访问剪贴板，请手动复制邀请码');
    },
    validateForm(refName) {
      return new Promise(resolve => {
        const form = this.$refs[refName];
        if (!form) {
          resolve(false);
          return;
        }
        form.validate(valid => resolve(Boolean(valid)));
      });
    },
    reportRequestError(error, fallback) {
      // 业务错误已由 request 拦截器展示；这里只补充 Axios 传输错误的真实信息。
      if (error && error.isAxiosError) this.$message.error(axiosErrorMessage(error, fallback));
    },
    rowActionBusy(id) {
      const sameFreezeRow = this.freezeSubmitting && this.freezeTarget && String(this.freezeTarget.id) === String(id);
      const sameHistoryRow = this.historyLoading && this.historyTarget && String(this.historyTarget.id) === String(id);
      return Boolean(this.removingIds[String(id)] || sameFreezeRow || sameHistoryRow);
    },
    isRemoving(id) {
      return Boolean(this.removingIds[String(id)]);
    },
    canEditRow(row) {
      return canEditInvitation(row);
    },
    canRemoveRow(row) {
      return canRemoveInvitation(row);
    },
    canCopyRow(row) {
      return canCopyInvitation(row);
    },
    canToggleFreezeRow(row) {
      return canToggleFreeze(row);
    },
    statusTags(row) {
      const tags = [];
      const assigned = Boolean(getRowAccount(row) || row.assigned_at);
      const bound = Boolean(row.device_code);
      tags.push({ key: 'assigned', label: assigned ? '已分配' : '未分配', type: assigned ? 'primary' : 'info' });
      tags.push({ key: 'bound', label: bound ? '已绑定' : '未绑定', type: bound ? 'success' : 'info' });

      const validity = normalizeNullableString(row.validity);
      const validityMap = {
        permanent: { label: '生效中', type: 'success' },
        not_active: { label: '未生效', type: 'info' },
        unclaimed: { label: '待领取计时', type: 'info' },
        // valid 沿用现有“生效中”展示。
        expired: { label: '已过期', type: 'warning' }
      };
      const validityTag = validityMap[validity] || { label: '生效中', type: 'success' };
      tags.push({ key: 'validity', label: validityTag.label, type: validityTag.type });
      if (row.frozen) tags.push({ key: 'frozen', label: '已冻结', type: 'danger' });
      if (row.removed) tags.push({ key: 'removed', label: '已删除', type: 'info' });
      return tags;
    },
    historyActionLabel(action) {
      const normalized = String(action || '').toLowerCase();
      if (normalized === 'freeze' || normalized === 'frozen') return '冻结';
      if (normalized === 'unfreeze' || normalized === 'unfrozen') return '解冻';
      return action || '-';
    },
    historyTagType(action) {
      return this.historyActionLabel(action) === '冻结' ? 'danger' : 'success';
    },
    formatDateTime(value) {
      return value || '-';
    },
    tableRowClassName({ row }) {
      return row.removed ? 'removed-row' : '';
    }
  }
};
</script>

<style scoped>
.filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 4px;
}

.filter-form .el-form-item {
  margin-right: 16px;
  margin-bottom: 12px;
}

.filter-form .el-input,
.filter-form .el-select {
  width: 188px;
}

.filter-actions {
  margin-left: auto;
}

.toolbar {
  display: flex;
  justify-content: flex-start;
  margin: 4px 0 16px;
}

.table-list {
  width: 100%;
}

.table-list >>> .removed-row {
  color: #909399;
}

.code-value {
  font-family: Menlo, Monaco, Consolas, monospace;
}

.cell-line {
  line-height: 20px;
  white-space: nowrap;
}

.cell-line span {
  display: inline-block;
  width: 34px;
  color: #909399;
}

.cell-note {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.freeze-reason {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
}

.row-actions .el-button {
  width: 28px;
  height: 28px;
  margin: 0 1px;
  padding: 0;
  font-size: 16px;
}

.row-actions .danger-action {
  color: #f56c6c;
}

.form-note {
  color: #909399;
  font-size: 12px;
}

.metadata-form .el-select {
  width: 100%;
}

.metadata-form .form-note {
  margin-top: 6px;
  line-height: 20px;
}

.dialog-alert {
  margin-bottom: 18px;
}

.invitation-manage >>> .el-dialog {
  max-width: calc(100vw - 32px);
}

.invitation-manage >>> .el-date-editor.el-input {
  width: 100%;
}

@media (max-width: 900px) {
  .filter-form {
    display: grid;
    grid-template-columns: repeat(2, minmax(260px, 1fr));
    column-gap: 12px;
  }

  .filter-form .el-form-item {
    display: flex;
    margin-right: 0;
  }

  .filter-form .el-form-item >>> .el-form-item__content {
    flex: 1;
  }

  .filter-form .el-input,
  .filter-form .el-select {
    width: 100%;
  }

  .filter-actions {
    margin-left: 0;
  }
}

@media (max-width: 620px) {
  .filter-form {
    grid-template-columns: 1fr;
  }
}
</style>
